import Vue from 'vue';
import {extend, localize, ValidationObserver, ValidationProvider} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {i18n} from '@/setup/i18n-setup';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// loop over all rules
for (let rule in rules) {
    // add the rule
    extend(rule, rules[rule]);
}

extend('password', {
    validate: (res, {other}) => res === other,
    message: 'The password confirmation does not match.',
    params: [{name: 'other', isTarget: true}]
});

extend("oneTimePassword", {
  validate: (res, {password}) => res === password,
  message: i18n.t('vee-validate.one-time-password'),
  params: ["password"]
});

extend("confirmPassword", {
  validate: (res, {password}) => res === password,
  message: i18n.t('vee-validate.confirm-password'),
  params: ["password"]
});

extend('moreThanZero', {
  validate: value => value > 0,
  message: 'should be set greater than 0',
  params: [{name: 'other', isTarget: true}]
});
extend('periodTermYear', {
  // create re like x/xxxx

  validate: value => value.match(/^[1-3|a-c]\/\d{4}$/),
  message: 'กำหนดภาคเรียนและปีการศึกษา(พ.ศ.) ตัวอย่าง 1/2565',
  params: [{name: 'other', isTarget: true}]
});
//  validate number only not allow special character and alphabet
extend('numberOnly', {
  validate: value => value.match(/^[0-9]*$/),
  message: 'กรุณากรอกตัวเลขเท่านั้น',
  params: [{name: 'other', isTarget: true}]
});


function loadLocale() {
    const code = i18n.locale;

    return import(`vee-validate/dist/locale/${code}.json`).then(locale => {
        localize(code, locale);
    });
}

loadLocale();
